import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import Avatar from '@mui/material/Avatar'
import WiFiIcon from '@mui/icons-material/Wifi';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';


import {
  Button,
  TextField
} from '@mui/material'

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  avatar: {
    margin: 10,
  },
  greenAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: 'rgba(71,237,62,1)',
  }

});


class WIFI extends Component {
  textFieldInputProps = {
    sx: { color: 'black' }
  }

  state = {
    value: 0,
    openChangeWiFi: false,
    hideOptions: true,
    hideChangePassword: true,
    hideChangeSSID: true,
    ssid: '',
    wifiindex: '',
    passErrortext: 'Password can not be empty',
    errorPass: true,
    passMatchtext: "Passwords do not match",
    errorConfirm: false,
    saveEnabled: false,
    password: ''
  };


  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value })
    if (prop === "password") {
      this.setState({ password: event.target.value })
      if (event.target.value.length > 0) {
        this.setState({
          passErrortext: '',
          saveEnabled: true,
          errorPass: false
        })
        
      } else {
        this.setState({
          passErrortext: 'Password can not be empty',
          saveEnabled: false,
          errorPass: true
        })
      }
    } else if (prop === "confirmpassword") {
      if (event.target.value === this.state.password ) {
        this.setState({
          passMatchrtext: '',
          saveEnabled: true,
          errorConfirm: false
        })
      } else {
        this.setState({
          passMatchrtext: 'Password can not be empty',
          saveEnabled: false,
          errorConfirm: true
        })
      }
    }
  }

  handleCallToRouter = (value) => {
    this.props.history.push(value);
  }

  componentDidMount() {
    this.props.reload()
  }

  handleChangeWiFiClose = () => {
    this.setState({
      openChangeWiFi: false
    });
  };

  handleNameSelected = () => {
    this.setState({
      hideChangeSSID: false,
      hideChangePassword: true
    });
  };

  handlePassSelected = () => {
    this.setState({
      hideChangeSSID: true,
      hideChangePassword: false
    });
  };

  handleChangeWiFiOpen = (wifi) => {
    if (wifi.index === this.state.wifiindex) {
      this.setState({
        openChangeWiFi: true,
        hideOptions: true,
        hideChangeSSID: true,
        hideChangePassword: true,
        wifiindex: -1,
        ssid: wifi.ssid
      });
    } else {
      this.setState({
        openChangeWiFi: true,
        hideOptions: false,
        hideChangeSSID: true,
        hideChangePassword: true,
        wifiindex: wifi.index,
        ssid: wifi.ssid
      });
    }
    

  };

  handleSaveWifiName = () => {
    this.props.updateWiFiName(this.state.wifiindex, this.state.ssid)
    this.setState({
      hideChangeSSID: true,
      hideChangePassword: true,
    });
  };

  handleSaveWifiPassword = () => {
    this.props.updateWiFiPassword(this.state.wifiindex, this.state.password)
    this.setState({
      hideChangeSSID: true,
      hideChangePassword: true,
    });
  };


  render() {
    const { classes } = this.props
    return (
      <div>
        < AppBar position = "static"
        style = {
          {
            marginLeft: 260,
            backgroundColor: "#55565A"
          }
        } >
          <Toolbar>
            <Typography variant="h5">
              My WiFi
          </Typography>
          </Toolbar>
        </AppBar>

        <div>
          <Grid container spacing={16}>
            <Grid item xs={4}>
              <Paper style={{
                marginTop: 2,
                marginLeft: 280,
                width: 300
              }}>
                <List >
                  {
                    this.props.wifi.map(n => {
                      return (
                        <MenuItem key={n.index} onClick={this.handleChangeWiFiOpen.bind(this, n)}
                          selected={n.index === this.state.wifiindex}
                          style={{
                            height: 60
                          }}>
                          <Avatar className={n.status === "Disabled" ? classes.avatar : classes.greenAvatar} >
                            <WiFiIcon />
                          </Avatar>
                          <ListItemText primary={n.ssid} secondary={n.index < 4 ? "Band 2.4 GHz" : "Band 5.0 GHz"} />
                        </MenuItem>
                      );
                    })}
                </List>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper style={{
                marginTop: 2,
                marginLeft: 170,
                width: 300
              }} hidden={
                this.state.hideOptions
              }>
                < Button onClick={this.handleNameSelected}
                  
                  style={
                    {
                      background: '#47ED3E',
                      fontWeight: 'bold',
                      borderRadius: 5,
                      border: 0,
                      color: '#55565A',
                      height: 40,
                      padding: '0 30px',
                      width: 200,
                      marginBottom: 0,
                      marginLeft: 50,
                      marginRight: 'auto',
                      marginTop: 170,
                      align: 'center'
                    }
                  } >
                  Change Name
          </Button>
                < Button onClick={this.handlePassSelected}
                  style={
                    {
                      background: '#47ED3E',
                      fontWeight: 'bold',
                      borderRadius: 5,
                      border: 0,
                      color: '#55565A',
                      height: 40,
                      padding: '0 30px',
                      width: 200,
                      marginBottom: 165,
                      marginLeft: 50,
                      marginRight: 'auto',
                      marginTop: 20

                    }
                  } >
                  Change Password
          </Button>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper style={{
                marginTop: 2,
                marginLeft: 60,
                width: 300
              }} hidden={
                this.state.hideChangeSSID
              }>
                <TextField
                  //margin="dense"
                  id="name"
                  placeholder="SSID"
                  type="text"
                  //color='white'
                  value={this.state.ssid}
                  onChange={this.handleChange('ssid')}
                  fullWidth
                  InputProps={this.textFieldInputProps}
                  style={{
                    background: 'white',
                    borderRadius: 5,
                    border: 0,
                    height: 39,
                    width: 200,
                    //padding: '0 30px',
                    marginTop: 170,
                    marginBottom: 0,
                    marginLeft: 50,
                    marginRight: 'auto'
                  }}
                />
                < Button onClick={this.handleSaveWifiName}
                  style={
                    {
                      background: '#47ED3E',
                      fontWeight: 'bold',
                      borderRadius: 5,
                      border: 0,
                      color: '#55565A',
                      height: 40,
                      padding: '0 30px',
                      width: 200,
                      marginBottom: 165,
                      marginLeft: 50,
                      marginRight: 'auto',
                      marginTop: 20

                    }
                  } >
                  SAVE
          </Button>
              </Paper>
              <Paper style={{
                marginTop: 2,
                marginLeft: 60,
                width: 300
              }} hidden={
                this.state.hideChangePassword
              }>
                <TextField
                  id="password"
                  placeholder="Password"
                  type="password"
                  onChange={this.handleChange('password')}
                  onKeyPress={this.kcPassword}
                  errorText={this.state.passErrorText}
                  fullWidth
                  error={this.state.errorPass}
                  InputProps={this.textFieldInputProps}
                  style={{
                    background: 'white',
                    borderRadius: 5,
                    border: 0,
                    height: 39,
                    width: 200,
                    //padding: '0 30px',
                    marginTop: 140,
                    marginBottom: 0,
                    marginLeft: 50,
                    marginRight: 'auto'
                  }}
                />
                <TextField
                  id="confirmpassword"
                  placeholder="Confirm password"
                  type="password"
                  error={true}
                  onChange={this.handleChange('confirmpassword')}
                  onKeyPress={this.kcPassword}
                  errorText={this.state.passMatchtext}
                  fullWidth
                  InputProps={this.textFieldInputProps}
                  style={{
                    background: 'white',
                    borderRadius: 5,
                    border: 0,
                    height: 39,
                    width: 200,
                    //padding: '0 30px',
                    marginTop: 20,
                    marginBottom: 0,
                    marginLeft: 50,
                    marginRight: 'auto'
                  }}
                  
              />
                < Button onClick={this.handleSaveWifiPassword}
                  disabled={!this.state.saveEnabled}
                  style={
                    {
                      background: '#47ED3E',
                      fontWeight: 'bold',
                      borderRadius: 5,
                      border: 0,
                      color: '#55565A',
                      height: 40,
                      padding: '0 30px',
                      width: 200,
                      marginBottom: 135,
                      marginLeft: 50,
                      marginRight: 'auto',
                      marginTop: 20

                    }
                  } >
                  SAVE
          </Button>
              </Paper>
            </Grid>

          </Grid>

        </div>
      </div>
    )

  }
}
export default withStyles(styles)(WIFI)